module.exports = __webpack_public_path__ + "static/media/copy.62ab76a8.svg";